var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"convstooltip",staticClass:"con-vs-tooltip",on:{"mouseout":_vm.mouseoutx,"mouseover":_vm.mouseoverx}},[_c('transition',{attrs:{"name":"tooltip-fade"}},[(_vm.active)?_c('div',{ref:"vstooltip",staticClass:"vs-tooltip text-base",class:[
        `vs-tooltip-${_vm.positionx || _vm.position}`,
        { 'after-none': _vm.noneAfter },
      ],style:(_vm.style)},[(_vm.title)?_c('h4',{style:(_vm.headerStyle)},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"tooltip-content"},[_vm._t("content")],2)]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }